import styled, { css } from 'styled-components';

type ScratchContainerAttributes = {
  $complete?: boolean;
  height: number;
  width: number;
};

export default styled.div<ScratchContainerAttributes>(
  ({ $complete, height, width }) => css`
    box-shadow: 0px 0px 10px 2px rgb(0 0 0);
    outline: 4px solid rgb(34 34 34);
    -webkit-user-select: none;

    height: ${height}px;
    border-radius: 4px;
    position: absolute;

    width: ${width}px;
    user-select: none;

    overflow: hidden;
    margin: 0px auto;

    > canvas:last-child {
      position: absolute;

      height: 100%;
      width: 100%;

      left: 0px;
      top: 0px;

      ${$complete &&
      css`
        display: none;
      `}
    }
  `
);
